/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { SegmentedOption } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function AccountsView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '24px 12px 40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        {' '}
        <div> </div> <div style={{ flex: '1' }}></div>{' '}
        <div style={{ display: 'flex', gap: '8px' }}>
          {' '}
          <button
            onClick={m.acctExportLedger}
            aria-label="Export the account ledger as CSV"
            className="scp-6bc9eb5"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11.5px',
              padding: '7px 14px',
              borderRadius: '99px',
              border: '1px solid var(--l12)',
              background: 'transparent',
              color: 'var(--text-mid)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-download-simple" style={{ fontSize: '12px' }}></i>Export ledger
          </button>{' '}
          <button
            onClick={m.acctLinkOpen}
            aria-label="Link account"
            className="scp-9d13bde"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11.5px',
              fontWeight: '500',
              padding: '7px 15px',
              borderRadius: '99px',
              border: '1px solid color-mix(in srgb, var(--slate-fill) 50%, transparent)',
              background: 'color-mix(in srgb, var(--slate-fill) 10%, transparent)',
              color: 'var(--slate)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-plus" style={{ fontSize: '12px' }}></i>Link account
          </button>{' '}
        </div>{' '}
      </div>{' '}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: '12px' }}>
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '14px 16px',
          }}
        >
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Composite equity
          </div>
          <div
            style={{
              fontSize: '22px',
              fontWeight: '600',
              letterSpacing: '-0.02em',
              marginTop: '4px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            $594,040
          </div>
          <div style={{ fontSize: '10.5px', color: 'var(--pos)', marginTop: '2px' }}>▲ +4.24% MTD</div>
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '14px 16px',
          }}
        >
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Funded
          </div>
          <div
            style={{
              fontSize: '22px',
              fontWeight: '600',
              marginTop: '4px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            3<span style={{ fontSize: '11px', color: 'var(--faint)' }}>{' · $178K'}</span>
          </div>
          <div style={{ fontSize: '10.5px', color: 'var(--pos)', marginTop: '2px' }}>Payout in 4d</div>
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '14px 16px',
          }}
        >
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            In challenge
          </div>
          <div
            style={{
              fontSize: '22px',
              fontWeight: '600',
              marginTop: '4px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            2<span style={{ fontSize: '11px', color: 'var(--faint)' }}>{' · $250K'}</span>
          </div>
          <div style={{ fontSize: '10.5px', color: 'var(--muted)', marginTop: '2px' }}>
            71% · 56% to target
          </div>
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '14px 16px',
          }}
        >
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Combined DD
          </div>
          <div
            style={{
              fontSize: '22px',
              fontWeight: '600',
              marginTop: '4px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            $9,820<span style={{ fontSize: '11px', color: 'var(--faint)' }}>{' / $32K'}</span>
          </div>
          <div style={{ fontSize: '10.5px', color: 'var(--muted)', marginTop: '2px' }}>31% used</div>
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '14px 16px',
          }}
        >
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Next payout
          </div>
          <div
            style={{
              fontSize: '22px',
              fontWeight: '600',
              marginTop: '4px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            4d<span style={{ fontSize: '11px', color: 'var(--faint)' }}>{' · FundedNext'}</span>
          </div>
          <div style={{ fontSize: '10.5px', color: 'var(--pos)', marginTop: '2px' }}>$3,820 eligible</div>
        </div>{' '}
      </div>{' '}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {' '}
        <div
          style={{
            display: 'flex',
            gap: '2px',
            padding: '3px',
            borderRadius: '99px',
            border: '1px solid var(--l8)',
          }}
        >
          {' '}
          {(m.acctTabs ?? []).map((t, i171) => (
            <Fragment key={i171}>
              {' '}
              <SegmentedOption bg={t?.bg} fg={t?.fg} fw={t?.fw} variant="b" onClick={t?.go}>
                {dc.t(t?.label)} <span style={{ opacity: '0.6' }}>·{dc.t(t?.n)}</span>
              </SegmentedOption>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ flex: '1' }}></div>{' '}
        <span style={{ fontSize: '11px', color: 'var(--muted2)' }}>Sort: by equity</span>{' '}
      </div>{' '}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '12px' }}>
        {' '}
        {(m.accounts ?? []).map((a, i172) => (
          <Fragment key={i172}>
            {' '}
            <div
              style={dc.css(
                `background:var(--surface);border:1px solid var(--card-line);box-shadow:var(--shadow-card);border-top:2px solid ${dc.s(a?.color)};border-radius:16px;padding:16px 18px;display:flex;flex-direction:column;gap:12px`,
              )}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                {' '}
                <div style={{ flex: '1', minWidth: '0' }}>
                  <div style={{ fontSize: '13px', fontWeight: '600' }}>{dc.t(a?.firm)}</div>
                  <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                    {dc.t(a?.plan)}
                  </div>
                </div>{' '}
                <span
                  style={dc.css(
                    `font-size:9px;font-weight:600;letter-spacing:0.05em;padding:3px 9px;border-radius:99px;background:${dc.s(a?.badgeBg)};color:${dc.s(a?.badgeFg)};white-space:nowrap`,
                  )}
                >
                  {dc.t(a?.badge)}
                </span>{' '}
              </div>{' '}
              <div>
                {' '}
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: '600',
                    letterSpacing: '-0.02em',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(a?.equityStr)}
                </div>{' '}
                <div
                  style={dc.css(
                    `font-size:11px;margin-top:2px;color:${dc.s(a?.pnlCol)};font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(a?.pnlStr)}
                </div>{' '}
              </div>{' '}
              {a?.hasTarget ? (
                <>
                  {' '}
                  <div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontSize: '10.5px',
                        marginBottom: '5px',
                      }}
                    >
                      <span style={{ color: 'var(--muted2)' }}>Profit target</span>
                      <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--text2)' }}>
                        {dc.t(a?.targetStr)}
                      </span>
                    </div>
                    <div
                      style={{
                        height: '6px',
                        borderRadius: '99px',
                        background: 'var(--l7)',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={dc.css(
                          `height:100%;width:${dc.s(a?.targetPct)};border-radius:99px;background:var(--pos)`,
                        )}
                      ></div>
                    </div>
                  </div>{' '}
                </>
              ) : null}{' '}
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '10.5px',
                    marginBottom: '5px',
                  }}
                >
                  <span style={{ color: 'var(--muted2)' }}>Drawdown</span>
                  <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--text2)' }}>
                    {dc.t(a?.ddStr)}
                  </span>
                </div>
                <div
                  style={{ height: '6px', borderRadius: '99px', background: 'var(--l7)', overflow: 'hidden' }}
                >
                  <div
                    style={dc.css(
                      `height:100%;width:${dc.s(a?.ddPct)};border-radius:99px;background:${dc.s(a?.ddCol)}`,
                    )}
                  ></div>
                </div>
              </div>{' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  fontSize: '10px',
                  color: 'var(--muted2)',
                  fontVariantNumeric: 'tabular-nums',
                  paddingTop: '2px',
                  borderTop: '1px solid var(--l5)',
                }}
              >
                <span style={{ paddingTop: '8px' }}>{dc.t(a?.foot)}</span>
                <span style={{ paddingTop: '8px', color: 'var(--faint)' }}>{dc.t(a?.id)}</span>
              </div>{' '}
            </div>{' '}
          </Fragment>
        ))}{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '16px 18px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Combined activity</div>
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
              Last 30 days · all accounts
            </div>
          </div>
          <div style={{ flex: '1' }}></div>
          <div style={{ display: 'flex', gap: '4px' }}>
            <span
              style={{
                fontSize: '10px',
                padding: '3px 9px',
                borderRadius: '99px',
                background: 'color-mix(in srgb, var(--slate-fill) 16%, transparent)',
                color: 'var(--slate)',
              }}
            >
              P&L
            </span>
            <span
              style={{ fontSize: '10px', padding: '3px 9px', borderRadius: '99px', color: 'var(--muted2)' }}
            >
              Payouts
            </span>
            <span
              style={{ fontSize: '10px', padding: '3px 9px', borderRadius: '99px', color: 'var(--muted2)' }}
            >
              Resets
            </span>
            <span
              style={{ fontSize: '10px', padding: '3px 9px', borderRadius: '99px', color: 'var(--muted2)' }}
            >
              DD events
            </span>
          </div>
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1.1fr 1.3fr 1fr 1.6fr 0.8fr 30px',
            fontSize: '9.5px',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: 'var(--faint)',
            fontWeight: '600',
            padding: '12px 4px 8px',
            borderBottom: '1px solid var(--l8)',
          }}
        >
          <span>Date</span>
          <span>Event</span>
          <span>Account</span>
          <span>Detail</span>
          <span style={{ textAlign: 'right' }}>Amount</span>
          <span></span>
        </div>{' '}
        {(m.acctLedger ?? []).map((l, i173) => (
          <Fragment key={i173}>
            {' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1.1fr 1.3fr 1fr 1.6fr 0.8fr 30px',
                alignItems: 'center',
                fontSize: '11.5px',
                padding: '11px 4px',
                borderBottom: '1px solid var(--l8)',
              }}
            >
              {' '}
              <span style={{ color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
                {dc.t(l?.date)}
              </span>{' '}
              <span>
                <span
                  style={dc.css(
                    `display:inline-flex;align-items:center;gap:5px;font-size:9px;font-weight:600;letter-spacing:0.05em;color:${dc.s(l?.evCol)}`,
                  )}
                >
                  <span
                    style={dc.css(`width:5px;height:5px;border-radius:50%;background:${dc.s(l?.evCol)}`)}
                  ></span>
                  {dc.t(l?.ev)}
                </span>
              </span>{' '}
              <span>
                <span
                  style={{
                    fontSize: '10px',
                    padding: '2px 9px',
                    borderRadius: '99px',
                    border: '1px solid var(--l12)',
                    color: 'var(--text-mid)',
                  }}
                >
                  {dc.t(l?.firm)}
                </span>
              </span>{' '}
              <span style={{ color: 'var(--muted)' }}>{dc.t(l?.detail)}</span>{' '}
              <span
                style={dc.css(`text-align:right;font-variant-numeric:tabular-nums;color:${dc.s(l?.amtCol)}`)}
              >
                {dc.t(l?.amt)}
              </span>{' '}
              <span style={{ textAlign: 'right', color: 'var(--faint)' }}>
                <i className="ph ph-caret-right" style={{ fontSize: '12px' }}></i>
              </span>{' '}
            </div>{' '}
          </Fragment>
        ))}{' '}
      </div>
    </div>
  );
}
